import {
  Breadcrumb,
  BreadcrumbItemText,
  BreadcrumbItem,
  BreadcrumbItemLink,
} from "@wk/components-react16";
import { useNavigate, useLocation } from "react-router-dom";

const BreadcrumbCom = ({ items = [] }) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // 检查当前是否为首页 (假设首页路径为 '/' 或 '/home')
  const isHomePage = location.pathname === "/" || location.pathname === "/home";
  
  // 如果是首页，不显示面包屑
  if (isHomePage || items.length === 0) {
    return null;
  }
  
  return (
    <Breadcrumb
      showLastChevron={false}
      onLinkClick={(e) => {
        console.log(e);
      }}
    >
      {items.map((item, index) => {
          return (
            <div key={index}>
              <span slot="breadcrumbTooltipItem">{item.breadName}</span>
              <BreadcrumbItem slot="breadcrumbItem" key={index}>
                {index === items.length - 1 ? (
                  <BreadcrumbItemText>{item.breadName}</BreadcrumbItemText>
                ) : (
                  <BreadcrumbItemLink
                    isPreventDefault
                    href={item.path}
                    onLinkClick={() => {
                      navigate(item.path);
                    }}
                  >
                    <span slot="breadcrumbItemLink">{item.breadName}</span>
                  </BreadcrumbItemLink>
                )}
              </BreadcrumbItem>
            </div>
          );
        })}
    </Breadcrumb>
  );
};

export default BreadcrumbCom;
